import React, { memo, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/layout/Layout";
import usePageTracking from "@/hooks/useTracking";

// Lazy load pages for better performance
const HomePage = lazy(() => import("@/pages/HomePage"));
const PartnerPage = lazy(() => import("@/pages/PartnerPage"));
const CompliancePage = lazy(() => import("@/pages/CompliancePage"));
const TeamPage = lazy(() => import("@/pages/TeamPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const WhySafePage = lazy(() => import("@/pages/WhySafePage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const CareersPage = lazy(() => import("@/pages/CareersPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));

// Minimal loading fallback
const PageLoader = () => null;

// Tracking wrapper - memoized to prevent unnecessary rerenders
const TrackingWrapper = memo(({ children }) => {
  usePageTracking();
  return children;
});

// Main routes - memoized
const MainRoutes = memo(() => (
  <Layout>
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/why-safe" element={<WhySafePage />} />
        <Route path="/partner" element={<PartnerPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Suspense>
  </Layout>
));

// App content without location dependency
function AppContent() {
  return (
    <TrackingWrapper>
      <MainRoutes />
      <Toaster position="top-right" richColors />
    </TrackingWrapper>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
